'use client'

import { Eye, EyeOff } from '@untitledui/icons'

export interface PasswordVisibilityToggleProps {
    isVisible: boolean
    onToggle: () => void
}

/**
 * The eye in a password field that shows or hides what was typed. Mouse only, like a password
 * manager's icon: keyboard users keep tabbing between the fields.
 */
const PasswordVisibilityToggle = ({ isVisible, onToggle }: PasswordVisibilityToggleProps) => (
    <button
        type="button"
        tabIndex={-1}
        aria-hidden
        onClick={onToggle}
        className="flex cursor-pointer border-none bg-transparent p-0 text-[#777da5] hover:text-[#10185a]">
        {isVisible ? <EyeOff className="size-[18px]" /> : <Eye className="size-[18px]" />}
    </button>
)

export default PasswordVisibilityToggle
